import PropTypes from 'prop-types'
import React, { Component } from 'react'
import Helmet from 'react-helmet'
import { injectIntl } from 'react-intl'

function decorator(config) {
  return ComposedComponent => {
    @injectIntl class Meta extends Component {
      static propTypes = {
        intl: PropTypes.object.isRequired
      }
      render() {
        const { intl } = this.props
        const { title, description = '', image = '', intlKey } = config
        const mainTitle = intl.formatMessage({
          id: 'meta.dofe_name',
          defaultMessage: 'The Duke of Edinburgh’s Award'
        })
        let translatedTitle = title

        if (intlKey) {
          translatedTitle = intl.formatMessage({
            id: config.intlKey,
            defaultMessage: title
          })
        }

        const meta = [
          {
            name: 'viewport',
            content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'
          },
          { 'http-equiv': 'X-UA-Compatible', content: 'IE=edge,chrome=1' },
          { charset: 'utf-8' },
          { property: 'site_name', content: '' },
          { property: 'og:image', content: image },
          { property: 'og:locale', content: 'en_US' },
          {
            property: 'og:title',
            content: mainTitle
          },
          // { property: 'og:description', card: description, content: description },
          { property: 'og:type', content: 'website' },
          { property: 'og:url', content: '' },
          { property: 'twitter:card', content: 'summary' },
          { property: 'twitter:site', content: '@' },
          { property: 'twitter:creator', content: '@' },
          { property: 'twitter:title', content: translatedTitle },
          { property: 'twitter:description', content: description },
          { property: 'twitter:image', content: image },
          { property: 'twitter:image:width', content: '200' },
          { property: 'twitter:image:height', content: '200' }
        ]

        return (
          <div>
            <Helmet
              title={mainTitle + ' - ' + translatedTitle}
              titleTemplate={mainTitle + ' - ' + translatedTitle}
              defaultTitle=""
              meta={meta}
            />
            <ComposedComponent {...this.props} />
          </div>
        )
      }
    }
    return Meta
  }
}

export default decorator
